import PropTypes from 'prop-types';

const intlShape = PropTypes.object; // eslint-disable-line react/forbid-prop-types

export { intlShape };
